import React from 'react';
import { useMediaQuery } from 'react-responsive';
import './Lower_topbar.css';
import { useTranslation } from 'react-i18next';

const LowerTopbar = () => {
  const isDesktop = useMediaQuery({ minWidth: 992 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  const isMobile = useMediaQuery({ maxWidth: 576 });

  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  return (
    <div className="lower-topbar">
      <div className={`custom-row ${isDesktop ? 'desktop' : ''} ${isTablet ? 'tablet' : ''} ${isMobile ? 'mobile' : ''}`}>
        <div className="row">
          <div className={`col ${isDesktop ? 'col-sm-9' : ''} ${isTablet ? 'col-sm-8' : ''} ${isMobile ? 'col-sm-12' : ''}`}>
            <div className="site-logo">
              <a href="/"><img className="logo-nav" src="images/logo_nav.png" alt="Professional inspectors"></img></a>
            </div>
          </div>
          <div className={`col ${isDesktop ? 'col-sm-3' : ''} ${isTablet ? 'col-sm-4' : ''} ${isMobile ? 'col-sm-12' : ''}`}>
            <div className="language-buttons">
              <button className={`flag-button ${i18n.language === 'fr' ? 'active' : ''}`} onClick={() => changeLanguage('fr')}>
                <img src="../images/france.png" /> 
              </button>
              <button className={`flag-button ${i18n.language === 'en' ? 'active' : ''}`} onClick={() => changeLanguage('en')}>
              <img src="../images/royaume-uni.png" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LowerTopbar;
